import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { TimeOutPopupService } from './timeout-popup.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map, catchError, tap, finalize } from 'rxjs/operators';
import { error } from 'console';
import { PERMISSION } from '../../../../../config';

declare var initAriaHidden: any;
declare var removeAriaHidden: any;
declare var LOGOUT: any;
declare var ADMIN_LOGOUT;
declare var ENV_PORTAL: any;
declare var PREMIER_LOGOUT_HOME: any;
declare var FIRSTNET_LOGOUT_HOME: any;
declare var MYATT_LOGOUT_HOME: any;

@Component({
    selector: 'app-timeout-popup',
    templateUrl: './timeout-popup.component.html',
    styleUrls: ['./timeout-popup.component.scss']
})

export class TimeOutPopUpComponent implements OnInit {
    @Output() tokenRefreshLink: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('sessionContainer', { static: true }) sessionContainerElement;
    @Input() envPortal: any = {};

    tPopup: any;
    logOutTimerModal: any;
    hdrFocusabbleElements: any;
    isIdleFlag: boolean;
    logoutAlertFlag: boolean;

    timeout = 20 * 60 * 1000;
    resetTime = 25 * 60 * 1000;
    // TEST TIMINGS
    // timeout = 5 * 1000;
    // resetTime = 15 * 1000;

    constructor(
        private timeoutPopupService: TimeOutPopupService,
        private httpClientService: HttpClient
        ) {
        this.isIdleFlag = false;
        this.logoutAlertFlag = false;
        this.hdrFocusabbleElements = undefined;
    }

    ngOnInit() {
        this.timeoutPopupService.getTimeoutStatus().subscribe(
            (status: boolean) => {
                if (status) {
                    this.resetTimerPopup();
                }
            },
        );
        this.checkAutoLogoutOut();
    }

    resetTimerPopup() {
        clearTimeout(this.tPopup);
        this.tPopup = setTimeout(() => {
            this.logOutPopup();
        }, this.resetTime );
    }

    logOutPopup() {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
            this.alertOpenPopup();
            this.logOutTimerModal = setTimeout(() => {
            this.autoLogoutOutPopup();
            }, this.timeout);
        } else {
            this.resetTimerPopup();
        }
    }

    alertOpenPopup() {
        this.isIdleFlag = true;
        document.body.classList.add('modal-open');
        this.loadFocustelementsTimer();
        setTimeout(() => { initAriaHidden(); }, 500);
    }

    resetSessionTimerPopup() {
        this.alertClosePopup();
        clearTimeout(this.logOutTimerModal);
        this.tokenRefreshLink.next();
        this.resetTimerPopup();
    }

    alertClosePopup() {
        document.body.classList.remove('modal-open');
        removeAriaHidden();
        this.isIdleFlag = false;
        this.hdrFocusabbleElements = undefined;
    }

    autoLogoutOutPopup() {
        sessionStorage.setItem('sapmp_isAutoLogout', 'TRUE');
        if (ENV_PORTAL.toUpperCase() == "DMPADMIN"){
            sessionStorage.removeItem('sapmp_isAutoLogout');
            window.location.href = ADMIN_LOGOUT;
        }else{
            // sessionStorage.clear();
            // localStorage.clear();
            // sessionStorage.setItem('sapmp_isAutoLogout', 'TRUE');
            // this.autoLogoutButton.nativeElement.click();
            this.callLogoutAPI().subscribe(resp => {
                console.log('Logout API response:', resp);
                sessionStorage.clear();
                localStorage.clear();
                sessionStorage.setItem('sapmp_isAutoLogout', 'TRUE');
                // window.location.href='/businessconsole/home';
                if (ENV_PORTAL == "fnabc") {
                    window.location.href = FIRSTNET_LOGOUT_HOME;
                } else if(ENV_PORTAL == "sapmp"){
                    window.location.href = LOGOUT;
                }else{
                    window.location.href = MYATT_LOGOUT_HOME;
                }
            }, error => {
                console.error('Logout API error:', error);
            });
            
            // window.location.href = LOGOUT;
        }
        // var evt = new CustomEvent("logoutCurrentUser");
        // document.dispatchEvent(evt);
    }

    // using 'sapmp_isAutoLogout' token only in this file to check whether the user is logged out due to inactivity
    logoutCurrentUserPopup(isConfirmPopUp?: boolean) {
        this.alertClosePopup();
        return;
        if (isConfirmPopUp) {
            if (this.envPortal.envVariable == 'fnabc') {
                // userLogout();
                // logoutHeaderChanges();
                this.logoutAlertOpenPopup();
            }
            else {
                //sessionStorage.setItem('sapmp_isAutoLogout', 'TRUE');
                // userLogout();
                setTimeout(() => {
                    window.location.href = this.envPortal.baseUrl;
                }, 1000);
            }
        }
        else {
            this.autoLogoutOutPopup();
        }
    }

    checkAutoLogoutOut() {
        if (sessionStorage.getItem('sapmp_isAutoLogout') === 'TRUE') {
            this.logoutAlertOpenPopup();
        }
    }

    logoutAlertOpenPopup() {
        this.logoutAlertFlag = true;
        document.body.classList.add('modal-open');
        this.loadFocustelementsTimer();
        setTimeout(() => { initAriaHidden(); }, 500);
    }

    logoutAlertClosePopup() {
        document.body.classList.remove('modal-open');
        removeAriaHidden();
        if (this.envPortal.envVariable === 'fnabc') {
        setTimeout(() => {
        window.location.href = this.envPortal.redirectUrl;
        }, 1000);
        }
        this.logoutAlertFlag = false;
        this.hdrFocusabbleElements = undefined;
        sessionStorage.removeItem('sapmp_isAutoLogout');
    }


    // model  focusing functionality
    loadFocustelementsTimer() {
        if (!this.hdrFocusabbleElements) {
            setTimeout(() => {
                const hdrFocusableEls = this.sessionContainerElement.nativeElement.querySelectorAll('a[href], area[href],' +
                    ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
                this.hdrFocusabbleElements = Array.prototype.slice.call(hdrFocusableEls);
                if(this.isIdleFlag) {
                    document.getElementById('timeoutContainerTitle').focus();
                }
                else if(this.logoutAlertFlag) {
                    document.getElementById('logoutContainerTitle').focus();
                }
            });
        }
    }


    hdrHandleKeydownTimer(event) {
        const hdrFocussedEl = event.target;
        if (event.shiftKey && event.keyCode === 9) {
            if (hdrFocussedEl === this.hdrFocusabbleElements[0]) {
                event.preventDefault();
                this.hdrFocusabbleElements[this.hdrFocusabbleElements.length - 1].focus();
            }
        } else if (event.keyCode === 9) {
            console.log(this.hdrFocusabbleElements);
            if (hdrFocussedEl === this.hdrFocusabbleElements[this.hdrFocusabbleElements.length - 1]) {
                event.preventDefault();
                // hdrFocusabbleElements[hdrFocusabbleElements.length - 1].focus();
                this.hdrFocusabbleElements[0].focus();
            }
        }
    }

    callLogoutAPI(){
        let ivUser = sessionStorage.getItem('iv-user');
        let source = ENV_PORTAL.toUpperCase();
        let headers = new HttpHeaders();
        // headers = headers.append('Authorization', 'Basic '+ PERMISSION[0]['basicAuth']);
        headers = headers.append('iv-user', ivUser);
        headers = headers.append('source', source);
        headers = headers.append('init', 'false');
        let url = "restservices/sapmp/v1/profile/logoutInfo";//this.utilityService.getEnvConfig().getLoginHistory;
        return this.httpClientService.get(url, {headers: headers, responseType: 'text' })
            .pipe(
            (res) => {
                // if (sessionStorage.getItem('sapmp_jwtToken') != null) {
                //   this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
                // }
                // this.lastLoginHistory.next(res.body);
                console.log('Logout API called successfully', res);
                return res;
            }, catchError(this.handleError));
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}